<template>
	<div id="slider-full">
		<VueSlickCarousel v-if="slides.length" v-bind="settings">
			<a
				v-for="slider in slides"
				:key="slider.imagem_id"
				class="slider-container-link"
				:href="slider.link"
			>
				<img :src="slider.tamanhos[0].nome_img" class="rounded-default img-responsive" alt="" />
			</a>
		</VueSlickCarousel>
	</div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
	name: 'Slider',
	components: { VueSlickCarousel },
	props: {
		arrows: {
			type: Boolean,
			default: false,
		},
		dots: {
			type: Boolean,
			default: false,
		},
		slides: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		settings() {
			return {
				arrows: this.arrows,
				dots: this.dots,
				dotsClass: 'slick-dots custom-dot-class',
				arrowsClass: 'slick-arrows custom-arrow-class',
				infinite: true,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1,
			};
		},
	},
	created() {},
};
</script>
<style>
#slider-full button.slick-next {
	right: 25px;
}
#slider-full button.slick-prev {
	left: 25px;
	z-index: 1;
}
#slider-full button.slick-dots {
	bottom: 18px;
}
#slider-full button.slick-prev:before,
#slider-full button.slick-next:before {
	border-radius: 2px;
}
</style>

<style lang="scss" scoped>
.slider-container-link {
	width: 100%;
}
.img-responsive {
	width: 100%;
	height: 100%;
	object-fit: scale-down;
}
</style>

